import React from 'react'

const ADMEmptyState = ({ width = '290', height = '275', fill = 'none' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M151.974 273.799H290" stroke="#273754" />
      <path d="M234 153.18V273.441" stroke="#273754" />
      <path
        d="M153.635 55.959C153.635 55.959 168.412 67.8367 170.979 71.5203C170.979 71.5203 180.123 57.2663 184.455 59.1882C188.786 61.1101 193.278 65.2742 191.834 65.5945C190.39 65.9148 188.145 65.114 188.145 65.114C188.145 65.114 187.682 70.2391 185.106 69.9187"
        stroke="#273754"
      />
      <path
        d="M157.863 112.066C157.863 112.066 164.34 217.605 146.047 267.574L149.868 273.179H117.331C117.331 273.179 113.776 138.939 113.776 109.965L157.863 112.066Z"
        fill="#004360"
      />
      <path
        d="M114.243 231.673L152.687 197.73C152.687 197.73 153.878 198.326 155.704 199.368C155.007 210.419 153.967 221.554 152.458 232.115C135.128 234.313 114.243 231.673 114.243 231.673H114.243Z"
        fill="#273754"
      />
      <path
        d="M140.966 180.61L139.43 105.18L165 118.68C165 118.68 192.693 189.739 169.593 209.437C146.494 229.136 105.587 232.018 105.587 232.018L100.294 240.186L94.9999 204.152L140.966 180.61Z"
        fill="#004360"
      />
      <path d="M95.0003 204.722L140.967 181.18" stroke="#273754" />
      <path d="M140.5 181.68L134 159.18" stroke="#2E3860" />
      <path
        d="M164.5 117.18C164.5 117.18 192.106 189.954 169.006 209.652C145.906 229.351 105 232.233 105 232.233"
        stroke="#273754"
      />
      <path
        d="M145.351 30.2274V43.9433L128.332 48.1194V24.973L145.351 20.7969V30.2274Z"
        fill="#E2E2FC"
      />
      <path
        d="M136.032 35.5645C136.446 35.5645 136.782 35.2287 136.782 34.8145C136.782 34.4002 136.446 34.0645 136.032 34.0645C135.618 34.0645 135.282 34.4002 135.282 34.8145C135.282 35.2287 135.618 35.5645 136.032 35.5645Z"
        fill="#273754"
      />
      <path
        d="M143.022 35.5645C143.437 35.5645 143.772 35.2287 143.772 34.8145C143.772 34.4002 143.437 34.0645 143.022 34.0645C142.608 34.0645 142.272 34.4002 142.272 34.8145C142.272 35.2287 142.608 35.5645 143.022 35.5645Z"
        fill="#273754"
      />
      <path d="M140.677 37.2279V30.2266H144.19" stroke="#273754" />
      <path d="M134.881 30.2277H138.394" stroke="#273754" />
      <path
        d="M129.454 33.8161V36.2474C128.14 36.2474 127.075 35.1842 127.075 33.8727C127.075 33.7998 127.078 33.7278 127.085 33.6565C127.218 32.1819 129.454 32.3355 129.454 33.8161Z"
        fill="#E2E2FC"
      />
      <path
        d="M129.454 36.2458C128.14 36.2458 127.075 35.1826 127.075 33.8711"
        stroke="#273754"
      />
      <path
        d="M139.003 40.6847C137.674 40.6847 136.596 39.6086 136.596 38.2812"
        stroke="#004360"
        strokeLinecap="round"
        stroke-linejoin="round"
      />
      <path d="M145.351 43.9434L128.332 48.1195" stroke="#273754" />
      <path
        d="M140.676 37.2343L139.14 37.6116"
        stroke="#273754"
        strokeLinecap="round"
      />
      <path
        d="M129.454 33.8155C129.454 33.8155 131.784 31.642 131.677 26.0898H145.353"
        stroke="#273754"
      />
      <path
        d="M145.352 28.5986C145.352 28.5986 148.734 26.7301 146.809 19.6298C146.809 19.6298 131.836 16.3198 127.398 24.1142L126.596 21.2847C126.596 21.2847 119.32 33.9372 128.332 40.1833"
        stroke="#273754"
      />
      <path
        d="M113.681 72.6815V109.785L166.329 122.703V81.3806C166.329 66.7282 156.31 53.969 142.057 50.4718C135.222 48.7946 127.994 50.3473 122.455 54.6826C116.916 59.018 113.681 65.6547 113.681 72.6815Z"
        fill="#E2E2FC"
      />
      <path
        d="M161.569 90.4757L169.055 60.7363C169.055 60.7363 183.814 62.2311 187.023 71.4135C187.023 71.4135 194.082 66.502 201.14 68.4239L189.376 100.242L170.477 104.408"
        fill="#004360"
      />
      <path
        d="M119.628 57.3047C119.628 57.3047 101.249 72.9082 112.586 106.435C123.923 139.961 183.738 100.643 182.959 89.9917C182.451 83.0515 174.52 88.4859 174.52 88.4859C174.52 88.4859 174.323 84.2751 172.825 86.7352C172.07 87.8956 171.434 89.129 170.926 90.4166L136.733 90.6323L136.638 75.2572"
        stroke="#273754"
      />
      <path
        d="M185.107 90.9004C185.107 90.9004 187.023 116.686 165.847 114.444"
        stroke="#273754"
      />
      <path d="M0 273.798H141.799" stroke="#273754" />
      <path
        d="M125.029 272.686C125.029 272.686 127.472 268.37 121.27 267.432C117.584 266.863 113.813 267.317 110.369 268.745C110.369 268.745 114.692 263.491 107.925 261.24C101.159 258.988 94.2052 264.242 94.2052 264.242C94.2052 264.242 100.971 251.67 95.7088 250.732C90.4463 249.794 87.6271 255.235 87.6271 255.235C87.6271 255.235 88.1909 239.662 77.2899 239.286C66.389 238.911 67.5167 259.176 67.5167 259.176C67.5167 259.176 62.818 250.169 54.9242 249.794C47.0304 249.419 50.9773 264.881 50.9773 264.881C50.9773 264.881 49.4737 261.24 44.2111 260.864C38.9486 260.489 39.3245 264.893 39.3245 264.893C39.3245 264.893 32.5584 255.423 25.0405 255.986C17.5226 256.549 20.7177 265.931 20.7177 265.931C13.0118 265.368 11.3203 273.799 11.3203 273.799H130.479L125.029 272.686Z"
        fill="#273754"
      />
      <path
        d="M222.705 108.271C234.489 108.271 244.042 117.763 244.042 129.472V153.918H201.368V129.472C201.368 117.763 210.921 108.271 222.705 108.271Z"
        fill="#2E3860"
      />
      <path
        d="M50.505 7.53321H50.505C72.6358 7.53321 90.5764 25.444 90.5764 47.538V93.6678H10.4336V47.538C10.4336 25.444 28.3742 7.5332 50.505 7.5332V7.53321Z"
        fill="#E2E2FC"
      />
      <rect
        x="207.465"
        y="127.291"
        width="30.4815"
        height="1.52243"
        fill="white"
      />
      <path
        d="M233.374 92.2946L206.321 115.498C226.515 98.7611 243.661 117.4 243.661 127.29L244.042 153.917L266.141 133.757V104.467C264.998 91.534 242.518 83.9263 233.374 92.2946Z"
        fill="#E2E2FC"
      />
      <path
        d="M244.042 153.917V129.878C244.042 118.365 234.47 109.031 222.662 109.031C215.893 109.031 209.858 112.099 205.94 116.886"
        stroke="#2E3860"
      />
      <path
        d="M10.4336 93.6678V47.538C10.4336 36.9281 14.6554 26.7527 22.1702 19.2503C29.6851 11.748 39.8774 7.5332 50.505 7.5332"
        stroke="#273754"
      />
      <path d="M50.503 0.179688V101.02" stroke="#273754" />
      <path d="M101.008 50.5988H0" stroke="#273754" />
      <path
        d="M201.368 153.037H200.868V154.037H201.368V153.037ZM243.661 153.537V154.037H243.853L243.995 153.91L243.661 153.537ZM266.475 133.749C266.681 133.565 266.698 133.249 266.514 133.043C266.329 132.838 266.013 132.82 265.808 133.005L266.475 133.749ZM201.368 154.037H243.661V153.037H201.368V154.037ZM243.995 153.91L266.475 133.749L265.808 133.005L243.327 153.165L243.995 153.91Z"
        fill="#2E3860"
      />
    </svg>
  )
}

export default ADMEmptyState
